import axios from 'axios';

export const uploadImages = async uploadData => {
  try {
    const { images, center_id, first_name, last_name, email, dob } = uploadData;

    // Create boundary
    const boundary = `----WebKitFormBoundary${Math.random().toString(36).slice(2)}`;

    // Create array of parts that will be joined later
    const parts = [];

    // Add each image to the form data
    images.forEach((image, index) => {
      // Image file part
      parts.push(`--${boundary}`);
      parts.push(`Content-Disposition: form-data; name="files[]"; filename="image_${image.direction}.png"`);
      parts.push('Content-Type: image/png');
      parts.push('Content-Transfer-Encoding: base64');
      parts.push('');
      parts.push(image.data.split(',')[1]);

      // Direction part
      parts.push(`--${boundary}`);
      parts.push(`Content-Disposition: form-data; name="directions[]"`);
      parts.push('');
      parts.push(image.direction);
    });

    // Add center_id if present
    if (center_id) {
      parts.push(`--${boundary}`);
      parts.push('Content-Disposition: form-data; name="center_id"');
      parts.push('');
      parts.push(center_id);
    }

    // Add first_name if present
    if (first_name) {
      parts.push(`--${boundary}`);
      parts.push('Content-Disposition: form-data; name="first_name"');
      parts.push('');
      parts.push(first_name);
    }

    // Add last_name if present
    if (last_name) {
      parts.push(`--${boundary}`);
      parts.push('Content-Disposition: form-data; name="last_name"');
      parts.push('');
      parts.push(last_name);
    }

    // Add email if present
    if (email) {
      parts.push(`--${boundary}`);
      parts.push('Content-Disposition: form-data; name="email"');
      parts.push('');
      parts.push(email);
    }

    // Add dob if present
    if (dob !== undefined) {
      parts.push(`--${boundary}`);
      parts.push('Content-Disposition: form-data; name="dob"');
      parts.push('');
      parts.push(dob);
    }

    // Add closing boundary
    parts.push(`--${boundary}--`);

    // Join all parts with CRLF
    const body = parts.join('\r\n');

    const response = await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_GATEWAY_BASE_URL}/upload`,
      data: body,
      headers: {
        'Content-Type': `multipart/form-data; boundary=${boundary}`,
        'x-api-key': process.env.REACT_APP_GATEWAY_API_KEY,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Upload error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    throw error;
  }
};
